export default "__VITE_ASSET__VOi1sPRi__$_?nuxt_component=async&nuxt_component_name=SvgoTradingOtcLiquidityIcon&nuxt_component_export=default__"